export default __webpack_public_path__ + "static/media/Srishti.c4cd71b0.jpg";